import notification from 'notification-js';
import Config from 'config';
import moment from 'moment';
import Profile from './Profile';
import stringToDom from 'string-to-dom';
import Spinner from 'spin';
import AuthDataStorage from "./AuthDataStorage";

export default class Subscription {
  constructor() {
    this.authDataStorage = new AuthDataStorage();
    var loggedIn = this.authDataStorage.getLoggedIn();
    if (!loggedIn && window.location.href.indexOf("account.html") > -1) {
      return window.location.href = "/";
    }

    if (window.location.href.indexOf("account.html") === -1) {
      return;
    }

    let queryStrings = window.location.search.substr(1).split("&");

    this.token = "";

    queryStrings.forEach((queryString) => {
      if (queryString.indexOf("token=") === 0) {
        this.token = queryString.substr(6);
      }
    });

    if (this.token) {
      this.executeSubscription();
    }

    this.trialPeriodElement = document.getElementsByClassName('trial-period')[0];
    this.redirectElement = document.getElementsByClassName('redirect')[0];
    this.noLicenceElement = document.getElementsByClassName('no-licence')[0];
    this.activeLicenceElement = document.getElementsByClassName('active-licence')[0];
    this.suspendedElement = document.getElementsByClassName('suspended')[0];
    this.licenceInfoElement = document.getElementsByClassName('current-package')[0];
    this.cancelledElement = document.getElementsByClassName('cancelled')[0];
    this.freeLicenseElement = document.getElementsByClassName('free-license')[0];
    this.purchasedAddonsElement = document.getElementsByClassName('purchased-addons')[0];
    var increaseLicenseElements = document.getElementsByClassName('buy-addons');

    for (let i = 0; i< increaseLicenseElements.length; i++) {
      increaseLicenseElements[i].onclick = function () {
        window.location.href = "/addons.html";
      };
    }

    let profile = new Profile({parentElement: document.getElementsByClassName('profile-info')[0]});
    this.showStatus();
    this.getAddons();

    this.overlay = document.getElementsByClassName('overlay')[0];
    this.spinner = new Spinner({
      color:'#fff',
      lines: 12,
      top: '50%', // Top position relative to parent
      left: '50%', // Left position relative to parent
      position: 'absolute' // Element positioning
    }).spin(this.overlay);
  }

  showStatus() {
    let userData = JSON.parse(this.authDataStorage.getUserData());
    let momentDate = moment(userData.licenceNextRenewal);

    let data = {
      file: './data/buy-now.json'
    };

    var xobj = new XMLHttpRequest();
    xobj.overrideMimeType("application/json");
    xobj.open("POST", Config.BACKEND_URL + '/getpage?t=' + Math.floor(Date.now() / 1000));
    xobj.onreadystatechange = function () {
      if (xobj.readyState == 4 && xobj.status == "200") {
        let licenceInfo = JSON.parse(xobj.response);
        let licences = licenceInfo.sections[0].prices; // get licence for marketing name
        let userData = JSON.parse(this.authDataStorage.getUserData());

        for (var i =0; i< licences.length; i++) {
          if (parseInt(licences[i].licenceId) == parseInt(userData.licencePlanId)) {
            this.licence = licences[i];
            break;
          }
        }

        if (this.licence) {
          this.licenceInfoElement.getElementsByClassName('name')[0].innerHTML = this.licence.name;
        }
      }
    }.bind(this);
    xobj.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    xobj.send(JSON.stringify(data));

    if (!userData.licenceIsActive) {
      return this.suspendedElement.style.display = 'block';
    }

    if (userData.licenceAgreementId && momentDate.isAfter(moment())) {
      if (userData.licenceIsCancelled && !this.token) {
        this.cancelledLicence(momentDate);
      } else if (this.token) {
        this.redirectElement.style.display = 'block';
      } else {
        this.activeLicence(momentDate, userData);
      }
    } else {
      if (momentDate.isAfter(moment()) && !this.token && userData.licenceAmount != 0) {
        this.trialPeriodElement.style.display = 'block';
        let userData = JSON.parse(this.authDataStorage.getUserData());

        let nextRenewalElement = this.trialPeriodElement.getElementsByClassName('nextRenewal')[0];

        let momentDate = moment(userData.licenceNextRenewal);
        nextRenewalElement.innerHTML = momentDate.format('MMMM Do YYYY');
        this.setupSubscriptionButton(this.trialPeriodElement);
      } else if (this.token) {
        this.redirectElement.style.display = 'block';
      } else if ((!this.token || !momentDate.isAfter(moment())) && parseInt(userData.licenceAmount) != 0) {
        this.noLicenceElement.style.display = 'block';
        this.setupSubscriptionButton(this.noLicenceElement);
      } else if ((!this.token || !momentDate.isAfter(moment())) && parseInt(userData.licenceAmount) == 0) {
        // user has free license
        this.freeLicenseElement.style.display = "block";

      }
    }
  }

  cancelledLicence(date) {
    this.cancelledElement.style.display = 'block';

    var nextBillingDate = this.cancelledElement.getElementsByClassName('next-billing-date')[0];

    nextBillingDate.innerHTML = date.format('MMMM Do YYYY');

    this.setupSubscriptionButton(this.cancelledElement);
  }

  activeLicence(date, userData) {
    if (userData.licenceAmount == 0) {
      this.freeLicenseElement.style.display = "block";
      return;
    }
    this.activeLicenceElement.style.display = 'block';

    var nextBillingDate = this.activeLicenceElement.getElementsByClassName('next-billing-date')[0];      

    nextBillingDate.innerHTML = date.format('MMMM Do YYYY');

    var billingAmount = this.activeLicenceElement.getElementsByClassName('billing-amount')[0];

    billingAmount.innerHTML = '&pound;' + (parseInt(userData.licenceAmount));

    var cancelAgreement = this.activeLicenceElement.getElementsByClassName('cancel-agreement')[0];

    cancelAgreement.onclick = function() {
      var xobj = new XMLHttpRequest();
      xobj.overrideMimeType("application/json");
      xobj.open("POST", Config.BACKEND_URL + '/cancelBillingAgreement');
      xobj.onreadystatechange = function () {
        if (xobj.readyState == 4 && xobj.status == "200") {
          var data = JSON.parse(xobj.response);
          if (data.success) {
            userData.licenceIsCancelled = true;
            this.authDataStorage.setUserData(JSON.stringify(userData));
            window.location.href = "/account.html"
          } else {
            this.showErrorMessage("Unable to cancel licence - please contact support");
          }
        }
      }.bind(this);
      xobj.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xobj.setRequestHeader("auth-token", userData.token);
      var data = {
        agreementId: userData.agreementId
      }
      xobj.send(JSON.stringify(data));
    }.bind(this);
  }

  setupSubscriptionButton(parentElement) {
    let setupPaymentButton = parentElement.getElementsByClassName('setup-payment')[0];

    setupPaymentButton.onclick = (event) => {
      event.preventDefault();
      window.location.href = "/payment.html";
    }
  }

  executeSubscription() {
    var request = new XMLHttpRequest();

    request.onreadystatechange = function() {
      if (request.readyState == 4) {
        if (request.status !== 200) {
          return;
        }

        var response = JSON.parse(request.responseText);
        if (response.success) {
          let userData = JSON.parse(this.authDataStorage.getUserData());
          userData.licenceAgreementId = response.agreementId;
          userData.licenceNextRenewal = response.nextRenewal;
          userData.licenceIsCancelled = false;
          this.authDataStorage.setUserData(JSON.stringify(userData));
          window.location.href = "/account.html";
        } else {
          this.showErrorMessage("Unable to setup payment - please try again or contact support");
        }
      }
    }.bind(this);

    var data = {
      token: this.token
    }

    let userData = JSON.parse(this.authDataStorage.getUserData());

    request.open("POST", Config.BACKEND_URL + '/executeBillingAgreement');
    request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    request.setRequestHeader("auth-token", userData.token);
    request.send(JSON.stringify(data));
  }

  getAddons() {

    this.addonsList = [];

    var request = new XMLHttpRequest();

    request.onreadystatechange = function() {
      if (request.readyState == 4) {
        if (request.status !== 200) {
          return;
        }

        var response = JSON.parse(request.responseText);
        if (response.success) {
          this.addonsList = response.list;
          this.showAddons();
        }
      }
    }.bind(this);

    let userData = JSON.parse(this.authDataStorage.getUserData());

    request.open("POST", Config.BACKEND_URL + '/retrieveGroupAddonLicenses');
    request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    request.setRequestHeader("auth-token", userData.token);
    request.send();
  }

  showAddons() {
    if (this.addonsList.length === 0) {
      return;
    }
    this.purchasedAddonsElement.style.display = "block";
    let addonsItemsContainer = this.purchasedAddonsElement.getElementsByClassName("purchased-addons-list")[0];
    for (let i=0; i < this.addonsList.length; i++) {
      if (!this.addonsList[i].GroupLicenceCompleted)
        continue;
      let addonDynamic = JSON.parse(this.addonsList[i].GroupLicenceDynamic);
      let template = `<div class="purchased-addons-item">
            <div class="purchased-addon-name">${addonDynamic.name} x${addonDynamic.count}</div>
            <div class="purchased-addon-amount">&pound;${addonDynamic.monthAmount} per month</div>
            <div class="purchased-addon-date">${this.addonsList[i].cancelled ? "Active till " : ""}${moment(this.addonsList[i].GroupLicenceNextRenewal).format('MMMM Do YYYY')}</div>
            <div class="purchased-addon-cancel">
                <button class="addon-agreement-cancel">Cancel Agreement</button>                
            </div>
            <div style="clear: both;"></div>
        </div>`;
      var rowElement = stringToDom(template);

      let cancelButton = rowElement.getElementsByClassName("addon-agreement-cancel")[0];

      if (this.addonsList[i].cancelled && !this.addonsList[i].parentGroupLicenseId) {
        cancelButton.style.display = "none";
        let setupPaymentButton = stringToDom('<button class="addon-agreement-setup">Setup payment</button>');
        rowElement.getElementsByClassName("purchased-addon-cancel")[0].appendChild(setupPaymentButton);
        setupPaymentButton.onclick = function (e) {
          window.location.href = "/payment.html?id=" + this.addonsList[i].LicenceId + "&groupLicence=" + this.addonsList[i].GroupLicenceId;
        }.bind(this);
      } else {
        cancelButton.dataset.id = this.addonsList[i].GroupLicenceId;
        cancelButton.dataset.agreementId = this.addonsList[i].agreementId ? this.addonsList[i].agreementId : 0;
        cancelButton.dataset.parentGroupLicenseId = this.addonsList[i].parentGroupLicenseId ? this.addonsList[i].parentGroupLicenseId : 0;
        let userData = JSON.parse(this.authDataStorage.getUserData());
        if (this.addonsList[i].parentGroupLicenseId && (!userData.licenceAgreementId || !this.addonsList[i].isActive || this.addonsList[i].cancelled)) {
          cancelButton.onclick = function (event) {
            window.location.href = "/payment.html" + (!this.addonsList[i].isActive ? "?suspended=true" : "");
          }.bind(this);
          cancelButton.innerText = "Setup payment";
        } else if (!this.addonsList[i].cancelled && !this.addonsList[i].isActive && this.addonsList[i].groupLicenseAgreementID) {
          // if payment was suspended let's try re-activate payments
          cancelButton.onclick = function (event) {
            this.reactivatePayments(this.addonsList[i].GroupLicenceId, this.addonsList[i].LicenceId);
          }.bind(this);
          cancelButton.innerText = "Setup payment";
          rowElement.getElementsByClassName("purchased-addon-date")[0].innerText = "Suspended";
        } else {
          cancelButton.onclick = function (event) {
            this.cancelAddonAgreement(event);
          }.bind(this);
        }
      }

      addonsItemsContainer.appendChild(rowElement);
    }
  }

  reactivatePayments(groupLicenseId, licenceId) {
    window.location.href = "/payment.html?id=" + licenceId + "&groupLicence=" + groupLicenseId + "&suspended=true";
  }

  cancelAddonAgreement(event) {
    var button = event.target;
    var addonLicenseId = parseInt(button.dataset.id);
    var agreementId = parseInt(button.dataset.agreementId);
    var parentGroupLicenseId = parseInt(button.dataset.parentGroupLicenseId);

    var body = document.body,
        html = document.documentElement;

    var height = Math.max( body.scrollHeight, body.offsetHeight,
        html.clientHeight, html.scrollHeight, html.offsetHeight );

    var width = Math.max(body.scrollWidth );

    this.overlay.style.display = 'block';
    this.overlay.style.height = height + 'px';
    this.overlay.style.width = width + 'px';


    var request = new XMLHttpRequest();

    request.onreadystatechange = function() {
      if (request.readyState == 4) {
        if (request.status !== 200) {
          return;
        }

        var response = JSON.parse(request.responseText);
        if (response.success) {
          let userData = JSON.parse(this.authDataStorage.getUserData());
          if (response.paymentDetails.payment != "credit_card")
            this.createNewAgreement(addonLicenseId, agreementId, parentGroupLicenseId, response.paymentDetails);
          else {
            if (parentGroupLicenseId) {
              this.packagePaymentPage();
            } else {
                this.addonsPaymentPage(addonLicenseId, agreementId);
            }
          }
        } else {
          this.overlay.style.display = "none";
          this.showErrorMessage("Unable to cancel licence - please contact support");
        }
      }
    }.bind(this);

    let data = {
      addonLicenseId,
      addonAgreementId: agreementId,
      parentGroupLicenseId
    };

    let userData = JSON.parse(this.authDataStorage.getUserData());

    request.open("POST", Config.BACKEND_URL + '/cancelBillingAgreement');
    request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    request.setRequestHeader("auth-token", userData.token);
    request.send(JSON.stringify(data));

  }

  createNewAgreement(addonLicenseId, agreementId, parentGroupLicenseId, paymentDetails) {
    let userData = JSON.parse(this.authDataStorage.getUserData());

    var endpoint = "/createBillingAgreement";
    if (agreementId) {
      endpoint = "/createAddonBillingAgreement";
    }

    var xobj = new XMLHttpRequest();
    xobj.overrideMimeType("application/json");
    xobj.open("POST", Config.BACKEND_URL + endpoint);
    xobj.onreadystatechange = function () {
      if (xobj.readyState == 4 && xobj.status == "200") {
        var data = JSON.parse(xobj.response);
        if (data.success) {
          if (data.approval_url) {
            window.location.href = data.approval_url;
          } else {
            window.location.href = "/account.html";
          }
        } else
          this.showErrorMessage("Unable to cancel licence - please contact support");
      }
    }.bind(this);
    xobj.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xobj.setRequestHeader("auth-token", userData.token);
    var data = {
      addonLicenseId,
      agreementId,
      parentGroupLicenseId,
      paymentTerm: paymentDetails.paymentTerm,
      payment: paymentDetails.payment,
      cart: paymentDetails.card,
      rewriteAgreement: true,
      licenceName: this.licence.name
    };
    xobj.send(JSON.stringify(data));
  }

  packagePaymentPage() {
    window.location.href = "/payment.html?rewrite=true";
  }

  addonsPaymentPage(cancelledAddonLicenseId, agreementId) {
    var ids = [];
    var addonsIds = [];
    for (let i = 0; i < this.addonsList.length; i++) {
      let item = this.addonsList[i];
      if (item.GroupLicenceId == cancelledAddonLicenseId || item.groupLicenseAgreementID != agreementId)
          continue;
      ids.push(item.LicenceId);
      addonsIds.push(item.GroupLicenceId);
    }
    if (ids.length > 0)
      window.location.href = "/payment.html?id=" + ids.join(',') + "&groupLicence=" + addonsIds.join(',') + "&rewrite=true";
    else
      window.location.reload();
  }

  showErrorMessage(message) {
    notification.notify( 'error', message, {
      notification: {position: [ 'right', 'top' ]}
    });
  }

}



// WEBPACK FOOTER //
// ./src/Subscription.js